import { render } from "./head.vue?vue&type=template&id=50360316&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=50360316&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50360316"]])

export default __exports__